// /* global dataLayer */
import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import {GoogleTagsKey} from "../../config/client-config";
import packageJson from '../../../package.json';
const Footer = () => {
  // const date = new Date()
  // const currentYear = date.getFullYear()

    useEffect(() => {
        ReactGA.initialize(GoogleTagsKey);
        ReactGA.send({
            page: window.location.pathname
        });

    // If you want to track events, uncomment the following lines
    // ReactGA.event({
        //     category: "category",
        //     action: "action",
        //     label: "label", // optional
        //     value: 99, // optional, must be a number
        //     nonInteraction: true, // optional, true/false
        //     transport: "xhr", // optional, beacon/xhr/image
        // });

    }, []);
    const version = packageJson.version.split('.').slice(0, 2).join('.');
  return (
      <footer className='footer-bottom-container'>
                  <div className='footer-block'>
                      <div className='footer-copyrights'>
                          © {new Date().getFullYear()} Communitism - {version}v
                          {/*| Licensed under CC.*/}
                      </div>
                      <div className='footer-developed-by'>
                          {/* Copyright {currentYear} &copy; All Rights Reserved -  */}
                          Developed by{' '}
                          <a
                              className='developed-by-link'
                              href='https://aart.gr'
                              target="_blank"
                              rel="noopener noreferrer"
                              aria-label="Email us at info@aart.gr"
                          >
                              ArtNet
                          </a>
                          <br/>
                          {/*<img src='/demo_logo.gif' width='50' height='50' alt='logo' />*/}
                      </div>
                  </div>
      </footer>
)}

export default Footer
